<template>
  <router-view :key="$route.fullPath"/>
</template>

<style>

</style>
